var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownArrowRed = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00503 7.7939C3.27839 8.06953 3.72161 8.06953 3.99497 7.7939L6.79497 4.97074C7.06834 4.69512 7.06834 4.24823 6.79497 3.97261C6.52161 3.69698 6.07839 3.69698 5.80502 3.97261L4.19934 5.59157L4.19934 0.705155C4.19934 0.315357 3.88594 -0.000634875 3.49934 -0.000634841C3.11274 -0.000634807 2.79934 0.315358 2.79934 0.705155L2.79934 5.59024L1.19497 3.97261C0.921607 3.69698 0.478392 3.69698 0.205025 3.97261C-0.0683421 4.24823 -0.068342 4.69512 0.205025 4.97074L3.00503 7.7939Z",
    fill: "#F1416C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownArrowRed);
export default ForwardRef;